import Spinner from '@/components/ui/spinner';

export const LoadingPage: React.FC = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <Spinner className="size-10 [&_*]:stroke-primary-dark" />
    </div>
  );
};
